/*
saikrishna 11/24/2022 3031450488 Created a new Ui for Reports
saikrishna 11/25/2022  3031450488 Added BasicInfo new Ui fields
akhila 1/12/2022 3031450488 added new UI for workqueue
Suresh Peddavoora 12/05/2022 3031450488 Modified Landing Page Format.
Ashraf 12/05/2022 3031450488 Fixed header labels
Prakash 12/08/2022  3031450488 Removed card component.
Ashraf 12/13/2022 3031450488 Renamed header labels
Dilip 12/28/2022 3031450488 Renamed header labels
*/
import React, {useContext, useState} from 'react';
import LandingPage from '../../../Pages/LandingPage';
import {ThemeContext} from '../../../themes/ThemeProvider';
import SearchRuleGroup from './../../FrameWorks/ReportMaster/SearchReportMaster';
import AddReport from './../../FrameWorks/Reports/AddReport/index';
const index = () => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [tabValue, setTabValue] = useState(0);
  const [openTemplate, setOpenTemplate] = useState(false);
  const [editExisting, setEditExisting] = useState('');
  const [copy, setCopy] = useState();
  const [workQueue, setWorkQueue] = useState(true);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  return (
    <>
      <LandingPage
        title={'Work Queue Setup'}
        showTabs={true}
        tabValue={tabValue}
        handleTabChange={handleChange}
        allAntTabs={[]}
      >
        <div className="global-field-dash-board">
          <div className={` ${classes.cardStyleWhite}`}>
            <div className={classes.root}>
              <div className={classes.subContent}>
                {tabValue === 0 && (
                  <SearchRuleGroup
                    setCopy={setCopy}
                    setTabValue={setTabValue}
                    openTemplate={openTemplate}
                    setOpenTemplate={setOpenTemplate}
                    setWorkQueue={setWorkQueue}
                    workQueue={workQueue}
                    copy={copy}
                    setEditExisting={setEditExisting}
                  />
                )}
                {tabValue === 1 && (
                  <AddReport
                    setTabValue={setTabValue}
                    setWorkQueue={setWorkQueue}
                    workQueue={workQueue}
                    editExisting={editExisting}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
};
export default index;
